export default __webpack_public_path__ + "static/media/calendaricon.f9dda35a.svg";